import React from "react";

export const AxisLineSeparator = () => {
    return (
        <div className={"axis-line-separator"}></div>
    );
}
